var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"aria-sort":_vm.ariaSort,"tabindex":_vm.tabIndex,"role":"columnheader","scope":"col"},on:{"click":function($event){return _vm.toggleSortStatus()}}},[_c('div',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }